var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirebase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 280",
    enableBackground: "new 0 0 300 280",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FAA61C",
    d: "M66.54,210.39l1.39-1.94l65.62-124.52l0.14-1.32l-28.93-54.34c-2.42-4.55-9.25-3.4-10.04,1.69L66.54,210.39 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FAA61D",
    d: "M67.36,208.91l1.05-2.05l64.94-123.21l-28.86-54.56 c-2.4-4.5-8.49-3.36-9.28,1.69L67.36,208.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1_9_",
    fill: "#FAA61C",
    d: "M67.36,208.91l1.05-2.05l64.94-123.21l-28.86-54.56c-2.4-4.5-8.49-3.36-9.28,1.69 L67.36,208.91z"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#FAA61C",
    d: "M154.78,123.71l21.54-22.06l-21.55-41.13c-2.05-3.89-7.76-3.9-9.78,0l-11.51,21.95v1.87L154.78,123.71z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FAA51A",
    d: "M154.39,122.79l20.94-21.45l-20.94-39.87 c-1.99-3.78-6.82-4.18-8.79-0.39l-11.57,22.29l-0.35,1.14L154.39,122.79z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-3_1_",
    fill: "#FAA61C",
    d: "M154.39,122.79l20.94-21.45l-20.94-39.87c-1.99-3.78-6.82-4.18-8.79-0.39l-11.57,22.29 l-0.35,1.14L154.39,122.79z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F58220",
    points: "66.54,210.39 67.17,209.76 69.45,208.83 153.42,125.17 154.49,122.27 133.54,82.35  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCE069",
    d: "M157.47,252.58l76-42.38l-21.7-133.65c-0.68-4.18-5.81-5.83-8.8-2.84L66.54,210.39l75.56,42.19 C146.87,255.24,152.69,255.24,157.47,252.58"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD31",
    d: "M232.78,209.84L211.24,77.2c-0.67-4.15-4.94-5.87-7.91-2.89L67.38,210.13l74.73,41.77 c4.74,2.65,10.51,2.65,15.25,0L232.78,209.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEAC38",
    d: "M157.47,251.33c-4.78,2.66-10.59,2.66-15.37,0l-74.95-41.58l-0.61,0.64l75.56,42.19 c4.78,2.67,10.59,2.67,15.37,0l76-42.38l-0.19-1.15L157.47,251.33z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.4d43f9da7916431fcdc364d8060b3e8a.svg";
export { ForwardRef as ReactComponent };